export type Activity = 'idle' | 'working' | 'attention' | 'done' | 'failed'

const ACTIVITY_PRECEDENCE: readonly Activity[] = ['working', 'failed', 'attention', 'done', 'idle']

export function strongestActivity(activities: Iterable<Activity>): Activity {
  let strongest: Activity = 'idle'
  for (const activity of activities) {
    if (ACTIVITY_PRECEDENCE.indexOf(activity) < ACTIVITY_PRECEDENCE.indexOf(strongest)) {
      strongest = activity
    }
  }
  return strongest
}
